import { Popover } from '@heathmont/moon-core-tw';
import Button from '~/client/shared/Button';
import Translate from '~/client/shared/i18n/Translate';
import QuickDeposit from './QuickDeposit';
import useQuickDepositButton from './useQuickDepositButton';

const QuickDepositButton: FC = () => {
  const { getAddress, loading, walletInfo, currency, isRtl } =
    useQuickDepositButton();

  return (
    <Popover position={isRtl ? 'top-end' : 'top-start'}>
      <Popover.Trigger>
        <Button onClick={() => getAddress()}>
          <Translate id="game.quick_deposit" />
        </Button>
      </Popover.Trigger>
      <Popover.Panel className="w-[22.75rem] p-6">
        <QuickDeposit
          loading={loading}
          walletInfo={walletInfo}
          currency={currency}
        />
      </Popover.Panel>
    </Popover>
  );
};

export default QuickDepositButton;
